module.exports = require('./helpers/bundle-url').getBundleURL('1suA6') + "logo-dark.eefe0b7f.svg";